import React from "react";
import AllEmpData from "./Components/AllEmpData";
import AddEmp from "./Components/AddEmp";

const AllEmployees = () => {
    return (
        <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
            <div className="row g-3">
                <AllEmpData />
            </div>
            <AddEmp />
        </div>
    );
};

export default AllEmployees;
